import { Select } from "@shopify/polaris";
import React, { useCallback } from "react";
import { reducerFn } from "../../../helper";

let optionsField = [
  { value: "created_at", label: "Task Created Date" },
  { value: "done_date", label: "Done Date" },
  { value: "need_review_at", label: "Need Review Date" },
];

export default function FilterTimeBy({ onChange }) {
  const [state, setState] = React.useReducer(reducerFn, {
    selected: [],
  });

  const handleSelectChange = useCallback((selected) => {
    if (onChange) {
      onChange(selected === "created_at" ? null : selected);
    }
    setState({ selected });
  }, []);

  return (
    <Select
      label="For"
      options={optionsField}
      value={state.selected}
      onChange={handleSelectChange}
    />
  );
}
